import request from '@/utils/httpClient'

import { MenuModel } from '@/model/Index'
export const defaultMenuModel: MenuModel = {
  id: 0,
  superId: 0,
  superName: '',
  type: 1,
  name: '',
  icon: '',
  path: '',
  url: '',
  order: '',
  children: []
}

// 创建菜单
export function createMenu(data?: object) {
  return request({
    url: 'access',
    method: 'POST',
    data
  })
}

// 更新菜单
export function updateMenu(id: number, data?: object) {
  return request({
    url: `access/${id}`,
    method: 'put',
    data
  })
}

// 批量删除菜单
export function deleteMenuById(id: number) {
  return request({
    url: `access/${id}`,
    method: 'delete'
  })
}

// 根据菜单id获取该菜单下的子菜单
export function getMenuListByMenuId(id: number, params?: object) {
  return request({
    url: `access/list/${id}`,
    method: 'get',
    params
  })
}

// 获取菜单树
export function getMenuTree(params?: object) {
  return request({
    url: 'access/tree',
    method: 'get',
    params
  })
}

// 获取菜单详情
export function getMenuDetailByDeptId(id: number) {
  return request({
    url: `access/${id}`,
    method: 'get'
  })
}
